export default __webpack_public_path__ + "static/media/icn-ongoing.29c0c977.svg";